import { render, staticRenderFns } from "./SelectOptionsMenu.vue?vue&type=template&id=8c52c9f0&scoped=true&"
import script from "./SelectOptionsMenu.vue?vue&type=script&lang=js&"
export * from "./SelectOptionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./SelectOptionsMenu.vue?vue&type=style&index=0&id=8c52c9f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c52c9f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VLayout,VList,VListItem,VListItemTitle})
